export const FEEDBACK_CONFIGS = [
  {
    feedback: "positive_filter",
    label: "Hard criteria",
    src: require("@/assets/images/recommendations/must-have.svg"),
    selectable: true,
  },
  {
    feedback: "positive_recent_employments_filter",
    label: "Hard criteria (recent employments only)",
    src: require("@/assets/images/recommendations/must-have.svg"),
    selectable: true,
  },
  {
    feedback: "positive",
    label: "Soft criteria",
    src: require("@/assets/images/recommendations/should-have.svg"),
    selectable: true,
  },
  {
    feedback: "negative_filter",
    label: "Disqualifier",
    src: require("@/assets/images/recommendations/must-not-have.svg"),
    selectable: true,
  },
  {
    feedback: "complex_filter",
    label: "Boolean expression",
    src: require("@/assets/images/recommendations/boolean.svg"),
    selectable: false,
  },
];

export const getFeedbackConfig = (type) =>
  FEEDBACK_CONFIGS.find(config => config.feedback === type);

export const getFeedbackLabel = (type, useDropdownLabel = false) => {
  const config = getFeedbackConfig(type);
  if (!config) return "";
  return (useDropdownLabel && config.dropdownLabel) ? config.dropdownLabel : config.label;
};
